export default {
  submitText: '确认',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      disabled: true,
      editDisabled: true,
      search: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
    },
    {
      label: '客户姓名',
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      search: true,
      disabled: true,
      rules: [
        { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
        {
          trigger: 'blur',
          min: 11,
          max: 11,
          message: '请输入11位手机号',
        },
      ],
    },
    {
      label: '区域名称',
      prop: 'regions',
      hide: true,
      type: 'tree',
      multiple: true,
      checkStrictly: true,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择通行区域',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleId',
      type: 'tree',
      dicData: [],
      props: {
        label: 'setmealName',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择收费标准',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '开始日期',
      prop: 'buyStartTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '套餐周期',
      prop: 'cycleNum',
      disabled: false,
      type: 'tree',
      dicData: [],
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      rules: [
        {
          required: true,
          message: '请选择套餐周期',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '结束时间',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      disabled: true,
    },
    {
      label: '优惠规则',
      prop: 'discountId',
      type: 'select',
      formslot:true,
      dicData: [],
      props: {
        label: 'discountName',
        value: 'id',
      },
      rules: [
        {
          required: false,
          message: '请选择优惠规则',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '应缴金额',
      prop: 'shouldMoney',
      precision: 2,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.01,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入应缴金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '收款单号',
      prop: 'payId',
      hide: true,
      display: false,
      rules: [
        {
          required: true,
          message: '请输入收款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退款单号',
      display: false,
      hide: true,
      prop: 'returnId',
      rules: [
        {
          required: true,
          message: '请输入退款单主键',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费标识',
      prop: 'returnFlag',
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费标识 0.未退费 1.已退费',
          trigger: 'change',
        },
      ],
    },
    {
      label: '退费金额',
      prop: 'returnMoney',
      display: false,
      hide: true,
      rules: [
        {
          required: true,
          message: '请输入退费金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '小区名称',
      prop: 'communityName',
      type: 'input',
      display:false,
      disabled: true,
    },
    {
      label: '楼栋',
      prop: 'buildingId',
      type: 'input',
      display:false,
      disabled: false,
      formslot: true,
    },
    {
      label: '房产信息',
      prop: 'areaName',
      type: 'input',
      disabled: true,
      readonly:true,
    },
    {
      label: '停车位',
      prop: 'lotNo',
      rules: [
        {
          required: false,
          message: '请输入停车位编号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '备注',
      prop: 'remark2',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 2,
      maxlength: 100,
      showWordLimit: true,
      overHidden: true,
      rules: [
        {
          required: false,
          message: '请输入备注',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车辆类型',
      prop: 'carType',
      hide: true,
      type: 'input',
      display:false,
      disabled: true,
    },
    {
      label: '车辆类别',
      prop: 'carCategory',
      hide: true,
      type: 'input',
      display:false,
      disabled: true,
    },
  ],
};
